import { combineReducers } from 'redux';

import destinations from './destinations';
import yachts from './yachts';
import notification from './notification';
import cabins from './cabins';
import user from './user';
import booking from './booking';
import cabinBooking from './cabinBooking';
import persisted from './persisted';
import planner from './planner';
import account from './account';
import ynf from './ynf';
import crewFinder from './crewFinder';
import bookingOptions from './bookingOptions';

export default combineReducers({
  destinations,
  yachts,
  notification,
  cabins,
  user,
  booking,
  persisted,
  cabinBooking,
  planner,
  account,
  ynf,
  crewFinder,
  bookingOptions
});
